import { Box, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import AvailableService from "../../../dumyData/company/CompanyAvailableServices.json";
import ServiceCard from "../../../components/serviceCard";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedServices } from "../../../lib/CompanySlice/SelectedServicesSlice";
import { setSelectionType } from "../../../lib/CompanySlice/SelectionTypeSlice";
import { t } from "i18next";

const SelectService = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const newServices = useSelector(
    (state) => state.seletedServicesReducer.selectedServices
  );

  const handleSelectServices = (params) => {
    let temmpArr = [...newServices];
    temmpArr.push(params);
    dispatch(setSelectedServices(temmpArr));
    dispatch(setSelectionType("create_appointment"));
  };

  return (
    <Stack height={"100vh"}>
      <Box p={2} bgcolor={"primary.main"}>
        <Typography variant="h5" fontWeight={500} color={"custom.white"}>
          {t("selectServices")}
        </Typography>
        <Typography fontSize={"0.75rem"} color={"custom.white"}>
          {t("doesntRepeat")}
        </Typography>
      </Box>
      <Box p={2} height={"100%"} overflow={"auto"}>
        {AvailableService.map((item, index) => {
          return (
            <React.Fragment>
              <Typography variant="h6">{item.category}</Typography>
              <Stack>
                {item.services.map((val, _ind) => {
                  return (
                    <ServiceCard
                      index={_ind}
                      data={val}
                      canSelectService={true}
                      handleSelectedService={handleSelectServices}
                    />
                  );
                })}
              </Stack>
            </React.Fragment>
          );
        })}

        {/* Add More service Button */}

        <Stack
          direction={"row"}
          alignItems={"center"}
          mt={2}
          gap={1.5}
          onClick={() => navigate("/company/catalogue")}
        >
          <IconButton
            sx={{
              backgroundColor: "custom.white",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "4px",
            }}
          >
            <AddIcon />
          </IconButton>
          <Typography variant="body2">{t("addNew")}</Typography>
        </Stack>
      </Box>
    </Stack>
  );
};

export default SelectService;
